export default __webpack_public_path__ + "static/media/start.40266aa7.svg";